import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import BrandBlogArticlePage from './BrandBlogArticlePage';

export default function BlogArticlePage() {
  return (
    <>
      <Navbar />
      <BrandBlogArticlePage
        publisher="山頂視角"
        brandName="山頂視角"
        englishName="PEAKVIEW"
      />
      <Footer />
    </>
  );
}
